"use strict";
import React from "react";
import PropTypes from "prop-types";

module.exports = (ComponentToAugment, connector) => {
    const uiStateComponent = (props, context) => <ComponentToAugment
        activeStepIndex={connector.activeStepIndex}
        errorMessages={connector.errorMessages}
        isFirstStep={connector.isFirstStep}
        isLastStep={connector.isLastStep}
        setValue={connector.setValue}
        setStepComplete={(stepIndex) => {
            connector.setStepComplete(stepIndex);
            props.stepCompleted(connector.values(), stepIndex, connector.activeStepIndex());
        }}
        setStepPrevious={connector.setStepPrevious}
        setWorkflowComplete={() => {
            connector.setWorkflowComplete();
            props.workflowCompleted(connector.values());
        }}
        setStepCount={(count) => {
            connector.setStepCount(count);
        }}
        setValidity={connector.setValidity}
        validity={connector.validity}
        values={() => connector.values}
        {...props}
    />;

    uiStateComponent.propTypes = {
        stepCompleted: PropTypes.func,
        workflowCompleted: PropTypes.func
    };
    uiStateComponent.defaultProps = {
        stepCompleted: () => {
        },
        workflowCompleted: () => {
        }
    };

    return {
        Component: uiStateComponent,
        values: connector.values.bind(connector),
        setValidity: connector.setValidity.bind(connector)
    };
};